import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('vehicle-management/index', {params});
    },
    show(id) {
        return Service().get('vehicle-management/show/'+id);
    },
    create(params) {
        return Service().post('vehicle-management/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('vehicle-management/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('vehicle-management/delete/'+id);
    },
    approval(id, params) {
        return Service().post('vehicle-management/approval/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
}